import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {adicionarFiltro, listarFiltros, removerFiltro} from '../../actions/interessado-promocao/usuariosPromocaoActions'
import {FILTRO_DATA_ENTRADA, FILTRO_EMAIL, FILTRO_NOME, FILTRO_PLATAFORMA, FILTRO_TIPO} from '../../util/filtros'
import FiltroBuscaInteressado from './FiltroBuscaInteressadosPromocao';
import FiltroChaveValor from '../comum/FiltroChaveValor';

export class FiltroInteressadosPromocao extends Component {

    adicionarFiltro(filtro) {
        this.props.adicionarFiltro(filtro)
    }

    removerFiltro(filtro) {
        this.props.removerFiltro(filtro)
    }

    render() {
        const {emails, nomes, plataformas} = this.props
        if (!nomes) {
            return <div>Carregando...</div>
        }
        return (
            <React.Fragment>
                <div className="conteudo">
                    <FiltroBuscaInteressado
                        filtro={FILTRO_DATA_ENTRADA}
                        opcoes={[new Date().getFullYear()]}
                        isFiltroData={true}
                    />

                    <FiltroChaveValor
                        filtro={FILTRO_NOME}
                        opcoes={nomes}
                        filtrosAdicionados={this.props.filtrosAdicionados}
                        adicionarFiltro={this.adicionarFiltro.bind(this)}
                        removerFiltro={this.removerFiltro.bind(this)}
                    />

                    <FiltroBuscaInteressado
                        filtro={FILTRO_EMAIL}
                        opcoes={emails}
                        filtrosAdicionados={this.props.filtrosAdicionados}
                        adicionarFiltro={this.adicionarFiltro.bind(this)}
                        removerFiltro={this.removerFiltro.bind(this)}
                    />

                    <FiltroBuscaInteressado
                        filtro={FILTRO_PLATAFORMA}
                        opcoes={plataformas}
                    />

                    <FiltroBuscaInteressado
                        isRadio
                        filtro={FILTRO_TIPO}
                        opcoes={['Desconto', 'Impressão']}
                    />

                </div>
            </React.Fragment>
        )
    }
}

export function mapStateToProps(state) {
    return {
        nomes: state.interessadoPromocao.filtrosInteressadosPromocao.nomes,
        emails: state.interessadoPromocao.filtrosInteressadosPromocao.emails,
        plataformas: state.interessadoPromocao.filtrosInteressadosPromocao.plataformas,
        filtrosAdicionados: state.interessadoPromocao.filtrosAdicionados
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        adicionarFiltro,
        removerFiltro,
        listarFiltros
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(FiltroInteressadosPromocao)
